export default __webpack_public_path__ + "static/media/ge1.6c1c659f.jpg";